import './catalogue-order.scss';
import AjaxLoad from '../../utilities/js/ajax-load';
import { dispatchForCode, createElementFromHTML, getOffset, smoothScrollTo } from '../../utilities/js/helper';
import { WidgetInstance } from 'friendly-challenge';

class CatalogueOrder {
    constructor (element) {
        this.$catalogueOrder = element;
        this.$catalogueOrderRoot = document.querySelector('[data-catalogue-order="root"]');
        this.$form = this.$catalogueOrder.querySelector('[data-catalogue-order="form"]');
        this.ajaxUrl = this.$form.getAttribute('action');
        this.$catalogueChoosesContainer = this.$catalogueOrder.querySelector('[data-catalogue-order="choose-catalogues"]');
        this.$catalogueChooses = this.$catalogueChoosesContainer.querySelectorAll('[data-catalogue-order-choose]');
        this.$cataloguesFormWrap = this.$form.querySelector('[data-catalogue-order="form-catalogues"]');
        this.$submitButton = this.$form.querySelector('button[type="submit"]');
        this.$formWrapper = this.$catalogueOrder.querySelector('[data-catalogue-order="formwrap"]');
        this.$loadingTarget = this.$catalogueOrder.querySelector('[data-catalogue-order="loading"]');
        this.$header = document.querySelector('[data-header="root"]');
        this.scrollOffset = 50;

        this.$zipCode = this.$form.querySelector('[data-catalogue-order="zipcode"]');
        this.lastZipCodeValue = this.$zipCode.value;

        this.ajaxActive = false;
        this.waitTimer = null;
        this.hasChanges = false;
        this.allowedKeys = [
            '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight'
        ];

        this.handleChange = (event) => {
            this.checkCatalogue(event.target);
        };
    }

    initialize () {
        this.setEvents();
        this.initCaptcha(this.$form);
        this.checkPreChoosenCatalogues();
    }

    initCaptcha ($form) {
        const $friendlyCaptcha = $form.querySelector('.frc-captcha');
        if ($friendlyCaptcha) {
            const widget = new WidgetInstance($friendlyCaptcha); // eslint-disable-line
        }
    }

    setEvents () {
        this.$catalogueChooses.forEach((catalogue) => {
            catalogue.addEventListener('change', this.handleChange);
        });

        this.$form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.checkBeforeSubmit(0);
        });

        this.$zipCode.addEventListener('keydown', (event) => {
            this.checkZipCode(event);
        });

        this.$zipCode.addEventListener('input', (event) => {
            this.checkZipCode(event);
        });
    }

    checkPreChoosenCatalogues () {
        const $selectedCatalogues = this.$form.querySelectorAll('[data-catalogue-order="select-catalogue"]:checked');

        if ($selectedCatalogues.length > 0) {
            $selectedCatalogues.forEach((catalogue) => {
                const $catalogueToChoose = this.$catalogueChoosesContainer.querySelector('[name="' + catalogue.getAttribute('name') + '"]');

                if ($catalogueToChoose) {
                    $catalogueToChoose.checked = true;
                    $catalogueToChoose.dispatchEvent(new CustomEvent('change'));
                }
            });
        }
    }

    checkZipCode (event) {
        const country = this.$form.querySelector('[name="catalogue_order[country]"]').value;

        if (window.browser.csshover) {
            dispatchForCode(event, (code) => {
                if (this.allowedKeys.includes(code)) {
                    if (code >= 0 && code <= 9) {
                        if (((country === 'AT' || country === 'CH') && this.$zipCode.value.length >= 4) || (country === 'DE' && this.$zipCode.value.length >= 5)) {
                            event.preventDefault();
                        } else {
                            if (this.$zipCode.value.length >= 2 && this.lastZipCodeValue !== this.$zipCode.value) {
                                this.hasChanges = true;
                            }
                        }
                    } else {
                        this.hasChanges = true;
                    }
                } else {
                    event.preventDefault();
                }
            });
        } else {
            let keysAllowed = false;

            if (this.$zipCode.value.length > this.lastZipCodeValue.length) {
                const lastKey = this.$zipCode.value.substring(this.lastZipCodeValue.length);

                if (lastKey.length > 1) {
                    let i = lastKey.length;

                    while (i--) {
                        keysAllowed = this.allowedKeys.includes(lastKey[i]);
                    }
                } else {
                    keysAllowed = this.allowedKeys.includes(lastKey);
                }

                if (keysAllowed) {
                    if (((country === 'AT' || country === 'CH') && this.$zipCode.value.length >= 5) || (country === 'DE' && this.$zipCode.value.length >= 6)) {
                        this.$zipCode.value = this.lastZipCodeValue;
                        this.hasChanges = false;
                    } else {
                        if (this.$zipCode.value.length >= 2 && this.lastZipCodeValue !== this.$zipCode.value) {
                            this.hasChanges = true;
                        }
                    }
                } else {
                    this.$zipCode.value = this.lastZipCodeValue;
                    this.hasChanges = false;
                }
            } else {
                if (this.$zipCode.value !== this.lastZipCodeValue) {
                    this.hasChanges = true;
                }
            }

            /*
            if (this.hasChanges) {
                this.checkBeforeSubmit();
            }
            */

            this.lastZipCodeValue = this.$zipCode.value;
        }
    }

    checkCatalogue (catalogue) {
        const $catalogue = this.$form.querySelector('[value="' + catalogue.dataset.catalogueOrderChoose + '"]');

        if ($catalogue) {
            $catalogue.checked = !!catalogue.checked;

            const checked = $catalogue.parentElement.querySelectorAll('input:checked');

            if (checked.length > 0) {
                $catalogue.parentElement.classList.remove('is--hidden');
            } else {
                $catalogue.parentElement.classList.add('is--hidden');
            }

            this.checkSubmitable();
        } else {
            console.warn('No catalogue found!!!');
        }
    }

    checkSubmitable () {
        const checkCount = this.$cataloguesFormWrap.querySelectorAll('input:checked').length;

        if (checkCount) {
            this.$submitButton.classList.remove('is--disabled');
        } else {
            this.$submitButton.classList.add('is--disabled');
        }
    }

    setResult (results) {
        this.ajaxActive = false;
        const $result = createElementFromHTML(results.html);

        if (results.success) {
            this.$catalogueOrder.innerHTML = '';
            this.$catalogueOrder.appendChild($result);
        } else {
            this.$formWrapper.innerHTML = '';

            this.$formWrapper.appendChild($result);

            this.$catalogueChooses.forEach((catalogue) => {
                catalogue.removeEventListener('change', this.handleChange);
            });

            this.$loadingTarget.querySelector('.loading')?.remove();

            this.scrollToFirstError(this.$formWrapper);

            const contentUpdateEvent = new CustomEvent('content.loaded', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: this.$catalogueOrderRoot
                }
            });

            window.dispatchEvent(contentUpdateEvent);
        }
    }

    checkBeforeSubmit (timer = 300) {
        clearTimeout(this.waitTimer);

        if (this.ajaxActive === false) {
            this.waitTimer = setTimeout(() => {
                this.$loadingTarget.appendChild(createElementFromHTML(window.OPTIONS.loader));
                this.sendRequest();
                this.ajaxActive = true;
            }, timer);
        } else {
            console.log('Please wait.....Ajax is running');
        }
    }

    sendRequest () {
        this.result = new AjaxLoad(this.ajaxUrl, {
            requestMethod: 'post',
            requestData: new FormData(this.$form),
            onSuccess: (resultText) => {
                const results = JSON.parse(resultText);
                this.checkResult(results);
                this.lastZipCodeValue = this.$zipCode.value;
            },
            onError: (error) => {
                console.warn(error);
            }
        });
    }

    checkResult (results) {
        if (typeof results.html !== 'undefined') {
            this.setResult(results);
        } else {
            if (typeof results.redirectUrl !== 'undefined') {
                location.href = results.redirectUrl;
            }
        }
    }

    scrollToFirstError ($form) {
        let headerHeight = 0;
        if (this.$header !== null) {
            headerHeight = parseInt(this.$header.offsetHeight);
        }
        const $firstError = $form.querySelectorAll('.has--error')[0];
        if ($firstError) {
            const errorScrollPosition = getOffset($firstError);
            smoothScrollTo(0, errorScrollPosition.top - headerHeight - this.scrollOffset);
        }
    }
}

export { CatalogueOrder };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $catalogueOrder = $context.querySelector('[data-catalogue-order="main"]');

        if ($catalogueOrder) {
            const $CatalogueOrder = new CatalogueOrder($catalogueOrder);
            $CatalogueOrder.initialize();
        }
    }
});
